import actionTypes from "../webActionTypes";


const reducers = {
    [actionTypes.beginCreateAllowance]: function (state, action) {
      return beginCreateAllowance(state, action);
    },

    [actionTypes.recvCreateAllowanceResult]: function (state, action) {
        return recvCreateAllowanceResult(state, action);
    },

    [actionTypes.recvCreateAllowanceError]: function (state, action) {
        return recvCreateAllowanceError(state, action);
    },

    [actionTypes.beginGetAllowanceList]: function (state, action) {
        return beginGetAllowanceList(state, action);
    },

    [actionTypes.recvGetAllowanceListResult]: function (state, action) {
        return recvGetAllowanceListResult(state, action);
    },

    [actionTypes.recvGetAllowanceListError]: function (state, action) {
        return recvGetAllowanceListError(state, action);
    },


    [actionTypes.beginGetAllowanceInfo]: function (state, action) {
        return beginGetAllowanceInfo(state, action);
    },

    [actionTypes.recvGetAllowanceInfoResult]: function (state, action) {
        return recvGetAllowanceInfoResult(state, action);
    },

    [actionTypes.recvGetAllowanceInfoError]: function (state, action) {
        return recvGetAllowanceInfoError(state, action);
    },    

    [actionTypes.delAllowanceInvoiceSuccess]: function (state, action) {
        return delAllowanceInvoiceSuccess(state, action);
    },
};

export default function createReducers(initialState) {
    return function reducer(state = initialState, action) {
        if (reducers.hasOwnProperty(action.type)) {
            return reducers[action.type](state, action);
        } else {
            return state;
        }
    };
}

function beginGetAllowanceList(state, action) {
    if (state.isGetAllowanceList) return state;

    return Object.assign({}, state, {
        isGetAllowanceList: true
    });
}

function recvGetAllowanceListResult(state, action) {

    const {
        payload
    } = action;

    const {totalCount, querykey, ids, data} = payload;

    if (ids.length === 0) {
        return state;
    }
    
    var allowanceList;

    if(querykey === state.querykey) {
        allowanceList = Object.assign({}, state.allowanceList, ids);        
    } else {
        allowanceList = Object.assign({}, {}, ids);
    }

    const allowances = Object.assign({}, state.allowances, data);

    return Object.assign({}, state, {
        allowanceList,
        allowances,
        totalCount,
        querykey,
        isGetAllowanceList: false,
    });
}


function recvGetAllowanceListError(state, action) {
    
    if (!state.isGetAllowanceList) return state;

    return Object.assign({}, state, {
        isGetAllowanceList: false
    });
}

function beginCreateAllowance(state, action) {
    if (state.isCreateAllowance) return state;

    return Object.assign({}, state, {
        isCreateAllowance: true
    });
}

function recvCreateAllowanceResult(state, action) {
    if (!state.isCreateAllowance) return state;

    return Object.assign({}, state, {
        isCreateAllowance: false,
    });
}

function recvCreateAllowanceError(state, action) {
    if (!state.isCreateAllowance) return state;

    return Object.assign({}, state, {
        isCreateAllowance: false,
    });
}

function beginGetAllowanceInfo(state, action) {
    if (state.isGetAllowanceInfo) return state;

    return Object.assign({}, state, {
        isGetAllowanceInfo: true
    });
}

function recvGetAllowanceInfoResult(state, action) {

    const {
        payload
    } = action;

    if(!payload)
        return state;

    const id = payload.allowancenumber;

    const allowance = state.allowances[id] || {};

    const newallowance = Object.assign(allowance, payload);

    const allowances = Object.assign({}, state.allowances, {[id]: newallowance});
  

    return Object.assign({}, state, {
        allowances,
        isGetAllowanceInfo: false,
    });
}

function recvGetAllowanceInfoError(state, action) {

    if (!state.isGetAllowanceInfo) return state;

    return Object.assign({}, state, {
        isGetAllowanceInfo: false
    });
}

function delAllowanceInvoiceSuccess(state, action) {

    const {
        allowanceList,
        totalCount,
    }= state;

    const {
        payload,
    } = action;

    const {
        allowanceNumber,
    } = payload;

    var index = 0;
    var new_allowanceList = {};
    var isFind = false;

    for(var key in allowanceList) {
        var allowance = allowanceList[key];
        
        if(allowance === allowanceNumber) {
            isFind = true;
        } else {
            new_allowanceList[index] = allowance;
            index++;
        }
    }

    var new_state = {
        allowanceList: new_allowanceList,
    }

    if(isFind) {
        new_state.totalCount = totalCount - 1;
    }

    return Object.assign({}, state, new_state);
}




// WEBPACK FOOTER //
// ./src/actions/reducers/allowanceReducers.js